// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import {
	GaGeneralPageName,
	GaGeneralEvent,
	createGAEvent,
} from '@/assets/ts/customEvent'
import { setCurrentGaPageName, getCurrentGaPageName } from '@/lib/utils'
import ShippingGlobal from '@/pages/shipping-global/components/_ShippingGlobal.vue'

hybridPage()

createApp({
	name: 'Shipping Global Page',
	components: {
		ShippingGlobal,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.ShippingGlobal)
		createGAEvent(GaGeneralEvent.PageLoad, {
			page_name: getCurrentGaPageName(),
		})

		const { shippingGlobalPageContent } = window.pageContent

		return {
			shippingGlobalPageContent,
		}
	},
}).mount('#bsMain')
